import React from "react";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
// import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";
// import { all_routes } from "../../../../Router/all_routes";
// import {
//   ChevronUp,
//   // Eye,
//   RotateCcw,
//   // Trash2,
// } from "feather-icons-react/build/IconComponents";
// import { setToogleHeader } from "../../../../core/redux/action";
import Table from "../../../../core/pagination/datatable";
import ViewContacts from "./ViewContacts";
// import { Download } from "react-feather";
// import Swal from "sweetalert2";
// import NewJobCard from "./NewJobCard";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
// import ViewJobCard from "./ViewJobCard";

const CRMContacts = () => {
  const dataSource = useSelector(
    (state) => state.rootReducer.CRMcustomer_Contacts,
  );
  // const route = all_routes;

  const columns = [
    {
      title: "FirstName",
      dataIndex: "firstName",
      sorter: (a, b) => a.firstName.length - b.firstName.length,
      render: (text) => {
        const truncatedText =
          text.length > 15 ? `${text.substring(0, 15)}...` : text;
        return (
          <Link
            to="#"
            className=""
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasRightViewContacts"
            aria-controls="#offcanvasRightViewContacts"
            title={text}
          >
            {truncatedText}
          </Link>
        );
      },
    },
    {
      title: "LastName",
      dataIndex: "lastName",
      sorter: (a, b) => a.lastName.length - b.lastName.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length,
      render: (text) => {
        const truncatedText =
          text.length > 15 ? `${text.substring(0, 15)}...` : text;
        return <span title={text}>{truncatedText}</span>;
      },
    },
    {
      title: "Company",
      dataIndex: "company",
      sorter: (a, b) => a.company.length - b.company.length,
      render: (text) => {
        const truncatedText =
          text.length > 15 ? `${text.substring(0, 15)}...` : text;
        return <span title={text}>{truncatedText}</span>;
      },
    },

    {
      title: "Phone",
      dataIndex: "phone",
      sorter: (a, b) => a.phone.length - b.phone.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Position",
      dataIndex: "position",
      sorter: (a, b) => a.position.length - b.position.length,
      render: (text) =>
        text.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Last Login",
      dataIndex: "lastLogin",
      sorter: (a, b) => a.lastLogin.length - b.lastLogin.length,
      render: (text) => {
        const truncatedText =
          text.length > 15 ? `${text.substring(0, 15)}...` : text;
        return <span title={text}>{truncatedText}</span>;
      },
    },
    {
      title: "Active",
      dataIndex: "active",
      render: (active) => (
        <div className="form-check form-switch">
          <input
            className="form-check-input"
            type="checkbox"
            role="switch"
            checked={active}
            onChange={(e) => console.log("Toggled:", e.target.checked)}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-flex justify-content-between mb-3 mt-2">
          <div className="">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/crm/dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item " aria-current="page">
                  Contacts
                </h4>
              </ol>
            </nav>
            <p className="text-muted">Manage and add new Contacts</p>
          </div>
          <div className="">
            {/* Back to List Button Section */}
            <div className="page-btn">
              <Link to="/crm/customers" className="btn btn-secondary">
                <i className="ti ti-arrow-left me-1"></i>
                Back
              </Link>
            </div>
          </div>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="d-flex flex-wrap row-gap-3 card-header align-items-center justify-content-between">
            <div className="search-set"></div>
            <div className="d-flex flex-wrap row-gap-3 table-dropdown align-items-center my-xl-auto right-content">
              <div className="dropdown me-2">
                <Link
                  to="#"
                  className="btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="modal"
                  data-bs-target="#add-units"
                >
                  <i className="ti ti-filter me-1"></i>
                </Link>
              </div>
              {/* <div className="dropdown me-2">
                <Link
                  to="#"
                  className="d-inline-flex btn btn-md btn-white dropdown-toggle align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Location
                </Link>
                <ul className="dropdown-menu dropdown-menu-end p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Hyderabad
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Bangalore
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      NewYork
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Germany
                    </Link>
                  </li>
                </ul>
              </div> */}
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <Table columns={columns} dataSource={dataSource} />
            </div>
          </div>
        </div>
      </div>
      <>
        <ViewContacts />
      </>
    </div>
  );
};

export default CRMContacts;
